export const MaineStars = {
  id: "mainestars",
  name: "Maine Stars",
  color: "#0F172A",
  lightColor: "#E2E8F0",
  logo: "⭐️",

  teams: [
    { id: "fame", name: "FAME", level: "L4 Junior - Flex - D2" },
    { id: "supergirls", name: "SUPERGIRLS", level: "L2 Junior - D2 - Medium" },
    { id: "bossladies", name: "BOSS LADIES", level: "L3 Senior - D2" },
    { id: "money", name: "MONEY", level: "L1 Mini - D2" },
    { id: "savage", name: "SAVAGE", level: "L5 Senior Coed - D2 - Large" },
    { id: "crush", name: "CRUSH", level: "L1 Youth - D2 - Medium" },
    { id: "glory", name: "GLORY", level: "L6 Limited Coed - XSmall" },
    { id: "charm", name: "CHARM", level: "L3 Youth - Flex - D2" },
  ],

  schedule: [
    // --- SATURDAY ---
    {
      day: "Saturday",
      time: "10:20 AM",
      teamId: "fame",
      meet: "9:44 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "11:07 AM",
      teamId: "supergirls",
      meet: "10:31 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:30 PM",
      teamId: "bossladies",
      meet: "12:54 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "2:54 PM",
      teamId: "money",
      meet: "2:18 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:37 PM",
      teamId: "savage",
      meet: "3:01 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:47 PM",
      teamId: "crush",
      meet: "3:11 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "4:40 PM",
      teamId: "glory",
      meet: "4:04 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "6:28 PM",
      teamId: "charm",
      meet: "5:52 PM",
      panel: "Hall B",
    },

    // --- SUNDAY ---
    {
      day: "Sunday",
      time: "9:07 AM",
      teamId: "fame",
      meet: "8:31 AM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "10:20 AM",
      teamId: "supergirls",
      meet: "9:44 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "11:06 AM",
      teamId: "bossladies",
      meet: "10:30 AM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "12:42 PM",
      teamId: "money",
      meet: "12:06 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "2:10 PM",
      teamId: "savage",
      meet: "1:34 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "2:14 PM",
      teamId: "crush",
      meet: "1:38 PM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "3:13 PM",
      teamId: "glory",
      meet: "2:37 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "4:42 PM",
      teamId: "charm",
      meet: "4:06 PM",
      panel: "Hall B",
    },
  ],
};
